import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, Target, Users } from 'lucide-react';
import { CTASection } from '../components/CTASection';
export function About() {
  const values = [{
    title: 'Dependability',
    desc: 'Executing on our commitments to keep your facilities operational.',
    icon: Shield
  }, {
    title: 'Modernization',
    desc: 'Continuously upgrading our fleet with the latest efficient technologies.',
    icon: Zap
  }, {
    title: 'Precision Safety',
    desc: 'Strict adherence to protocols protecting our personnel and your site.',
    icon: Target
  }, {
    title: 'Client Partnership',
    desc: 'Fostering enduring relationships through superior service execution.',
    icon: Users
  }];
  return <main className="flex-grow" data-id="element-179">
      {/* Hero */}
      <div className="bg-brand-navy py-32 relative overflow-hidden text-center" data-id="element-180">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }} data-id="element-181"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4" data-id="element-182">
          <motion.h1 initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="text-5xl md:text-7xl font-heading font-extrabold text-white mb-6 leading-tight" data-id="element-183">
            Powering Critical Operations Since{' '}
            <span className="text-brand-amber" data-id="element-184">2020</span>
          </motion.h1>
        </div>
      </div>

      {/* Timeline / Story */}
      <section className="py-24 bg-white" data-id="element-185">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
          <div className="max-w-3xl mx-auto" data-id="element-187">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="prose prose-lg text-brand-slate" data-id="element-188">
              <h2 className="text-3xl font-heading font-bold text-brand-navy mb-8" data-id="element-189">
                Our Foundation
              </h2>
              <p className="mb-6" data-id="element-190">
                Founded in early 2020, we entered the UK temporary heating and
                cooling market with a clear objective: to elevate the standard
                of equipment rental through superior engineering expertise and
                modern, efficient assets.
              </p>
              <p className="mb-6" data-id="element-191">
                We supply premium temperature control systems to commercial
                entities, industrial facilities, and public sector
                organizations. Our dedicated personnel work relentlessly to
                prevent disruption to your essential operations.
              </p>
              <p data-id="element-192">
                While our corporate entity is relatively new, our executive and
                engineering teams possess decades of collective experience in
                the specialized HVAC rental sector. This deep industry knowledge
                enables us to architect and deploy complex solutions rapidly and
                safely.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Team Stats Bar */}
      <section className="bg-brand-light py-12 border-y border-gray-200" data-id="element-193">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
          <div className="flex flex-wrap justify-center gap-12 md:gap-24" data-id="element-195">
            {[{
            label: 'Combined Experience',
            value: '50+ Yrs'
          }, {
            label: 'UK Depots',
            value: 'Strategic'
          }, {
            label: 'Equipment Age',
            value: '< 3 Yrs'
          }].map((stat, i) => <div key={i} className="text-center" data-id="element-196">
                <div className="text-3xl font-heading font-bold text-brand-navy mb-1" data-id="element-197">
                  {stat.value}
                </div>
                <div className="text-sm font-medium text-brand-slate uppercase tracking-wider" data-id="element-198">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Values Grid */}
      <section className="py-24 bg-white" data-id="element-199">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
          <div className="text-center mb-16" data-id="element-201">
            <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-brand-navy" data-id="element-202">
              Core Principles
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-203">
            {values.map((value, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-brand-light p-10 rounded-xl border border-gray-100 flex items-start" data-id="element-204">
                <div className="w-14 h-14 bg-white rounded shadow-sm flex items-center justify-center flex-shrink-0 mr-6 text-brand-amber" data-id="element-205">
                  <value.icon className="w-7 h-7" data-id="element-206" />
                </div>
                <div data-id="element-207">
                  <h3 className="text-xl font-heading font-bold text-brand-navy mb-3" data-id="element-208">
                    {value.title}
                  </h3>
                  <p className="text-brand-slate leading-relaxed" data-id="element-209">
                    {value.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-210" />
    </main>;
}